import * as AccessibleIcon from '@radix-ui/react-accessible-icon'
import React, { SVGProps } from 'react'

const Minus: React.FC<SVGProps<SVGSVGElement>> = props => {
  const label = 'minus'
  return (
    <AccessibleIcon.Root label={label}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        {...props}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 12.0001C5 11.4478 5.52235 11.0001 6.16668 11.0001H17.8333C18.4777 11.0001 19 11.4478 19 12.0001C19 12.5523 18.4777 13.0001 17.8333 13.0001H6.1667C5.52236 13.0001 5 12.5523 5 12.0001Z"
          fill="currentColor"
        />
      </svg>
    </AccessibleIcon.Root>
  )
}

export default Minus
